<script>
    // ═══ ПРЕДЛОЖЕНИЕ (Y/N) ═══
    // Обмен, продажа, лечение, приглашение — всё, что требует ответа.
    // Панель в том же языке, что экраны бизнесов и магазин 24/7: SF Pro Display,
    // тёмная карточка, золото, крупные клавиши. Плюс звук на появление: раньше
    // предложение приходило молча и его пропускали.
    import { fly } from 'svelte/transition';
    import '../../../business/menu/fonts/SFPro/stylesheet.css';

    export let visible1 = false;
    export let subTitle1 = '';
    export let title1 = '';
    export let desc1 = '';

    const LIFE = 10;              // столько секунд геймод держит предложение
    let left = LIFE;
    let timer = null;

    let expired = false;
    $: show = visible1 && subTitle1 === 'Предложение' && !expired;
    $: if (!visible1) expired = false;

    // Короткий двухтоновый сигнал: файл не нужен, работает и без CDN.
    const beep = () => {
        try {
            const AC = window.AudioContext || window.webkitAudioContext;
            if (!AC) return;
            const ctx = new AC();
            const play = (freq, at, dur, vol) => {
                const osc = ctx.createOscillator(), gain = ctx.createGain();
                osc.type = 'sine';
                osc.frequency.setValueAtTime(freq, ctx.currentTime + at);
                gain.gain.setValueAtTime(0.0001, ctx.currentTime + at);
                gain.gain.exponentialRampToValueAtTime(vol, ctx.currentTime + at + 0.02);
                gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + dur);
                osc.connect(gain); gain.connect(ctx.destination);
                osc.start(ctx.currentTime + at); osc.stop(ctx.currentTime + at + dur + 0.02);
            };
            play(784, 0, 0.16, 0.14);      // соль
            play(1046, 0.11, 0.22, 0.11);  // до — короткий «дзинь»
            setTimeout(() => { try { ctx.close(); } catch (e) {} }, 900);
        } catch (e) {}
    };

    // Только ПЕРЕХОД скрыто→показано: раньше реактивный блок читал и писал
    // timer, Svelte перезапускал его по кругу — сигнал «строчил» без конца,
    // а секундомер каждый раз сбрасывался на 10 и стоял на месте.
    const stopTimer = () => { if (timer) { clearInterval(timer); timer = null; } };
    const startTimer = () => {
        stopTimer();
        timer = setInterval(() => {
            left = Math.max(0, left - 0.1);
            // время вышло — гасим карточку сами, даже если геймод забыл спрятать
            if (left <= 0) { stopTimer(); expired = true; }
        }, 100);
    };
    let wasShow = false;
    $: if (show !== wasShow) {
        wasShow = show;
        if (show) { left = LIFE; beep(); startTimer(); }
        else stopTimer();
    }

    // Из текста геймода достаём имя, сумму и суть — остальное отбрасываем.
    const clean = (s) => String(s || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    // имя = два слова с большой буквы ОДНОГО алфавита (иначе цепляется слово «Игрок»)
    const NAME_RE = /([A-Z][a-z]+[ _][A-Z][a-z]+|[А-ЯЁ][а-яё]+[ _][А-ЯЁ][а-яё]+)/;
    const MONEY_RE = /(\d[\d\s.,]{2,})\s*\$/;

    $: text = clean(desc1).replace(/^Игрок\s+/i, '');
    $: who = (() => {
        const m = text.match(NAME_RE);
        return m ? m[1].replace(/_/g, ' ') : (title1 || 'Игрок');
    })();
    $: money = (() => { const m = text.match(MONEY_RE); return m ? m[1].trim() : ''; })();
    // суть: без имени, без суммы и без хвоста «Нажмите Y…» — клавиши и так на кнопках
    $: subject = (() => {
        let s = text.split(/\s*Нажми/)[0];
        const m = s.match(NAME_RE);
        if (m) s = s.replace(m[1], '');
        s = s.replace(/\s*(за|на сумму)?\s*\d[\d\s.,]{2,}\s*\$/, '');
        s = s.replace(/^[\s,.:;—-]+/, '').replace(/[\s,.:;—-]+$/, '').replace(/\s+/g, ' ').trim();
        if (!s) return title1 || 'Предложение';
        return s.charAt(0).toUpperCase() + s.slice(1);
    })();
    $: initial = (who || '?').trim().charAt(0).toUpperCase();
    $: urgent = left <= 3;
</script>

{#if show}
<div class="of" transition:fly={{ y: 30, duration: 260 }}>
    <div class="of__head">
        <div class="of__ava">{initial}</div>
        <div class="of__who">
            <div class="of__kick">Предложение{title1 ? ' · ' + title1 : ''}</div>
            <div class="of__name">{who}</div>
        </div>
        <div class="of__timer" class:urgent><b>{Math.ceil(left)}</b><span>сек</span></div>
    </div>

    <div class="of__body">
        <div class="of__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
                 stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"/><path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/>
            </svg>
        </div>
        <div class="of__subject">
            <div class="of__lbl">Суть</div>
            <div class="of__value">{subject}</div>
        </div>
        {#if money}
            <div class="of__money"><span>$</span>{money}</div>
        {/if}
    </div>

    <div class="of__acts">
        <div class="of__btn of__btn--yes"><b>Y</b> Принять</div>
        <div class="of__btn"><b>N</b> Отказаться</div>
    </div>

    <div class="of__bar"><i style="width:{(left / LIFE) * 100}%"></i></div>
</div>
{/if}

<style>
    .of {
        position: fixed; left: 50%; bottom: 9vh; transform: translateX(-50%);
        z-index: 60; width: 33.48vh; box-sizing: border-box;
        padding: 1.24vh 1.24vh 1.49vh; border-radius: 1.24vh;
        background: #1B1B1E;
        box-shadow: 0 1.24vh 3.1vh rgba(0, 0, 0, .55);
        font-family: 'SF Pro Display', sans-serif;
        pointer-events: none; overflow: hidden;
        --gold: #E7AE3F; --muted: rgba(242, 240, 235, .45);
    }

    .of__head { display: flex; align-items: center; gap: 0.87vh; }
    .of__ava {
        width: 3.22vh; height: 3.22vh; flex-shrink: 0; border-radius: 0.87vh;
        display: flex; align-items: center; justify-content: center;
        background: var(--gold); color: #221903;
        font-size: 1.92vh; font-weight: 600;
    }
    .of__who { min-width: 0; }
    .of__kick {
        font-size: 0.88vh; font-weight: 600; letter-spacing: 0.13vh;
        text-transform: uppercase; color: var(--gold);
    }
    .of__name {
        margin-top: 0.19vh; font-size: 1.3vh; font-weight: 600; color: #F2F0EB;
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .of__timer {
        margin-left: auto; flex-shrink: 0; display: flex; align-items: baseline; gap: 0.37vh;
        padding: 0.56vh 0.99vh; border-radius: 0.87vh; background: #26262A;
    }
    .of__timer b { font-size: 1.36vh; font-weight: 600; color: #F2F0EB; }
    .of__timer span { font-size: 0.68vh; font-weight: 500; color: var(--muted); }
    .of__timer.urgent b { color: var(--gold); }

    .of__body {
        display: flex; align-items: center; gap: 0.87vh;
        margin-top: 0.99vh; padding: 0.99vh 1.12vh; border-radius: 0.93vh; background: #232327;
    }
    .of__icon {
        width: 2.73vh; height: 2.73vh; flex-shrink: 0; border-radius: 0.74vh;
        display: flex; align-items: center; justify-content: center;
        background: rgba(231, 174, 63, .12); color: var(--gold);
    }
    .of__icon svg { width: 1.36vh; height: 1.36vh; }
    .of__subject { min-width: 0; flex: 1; }
    .of__lbl { font-size: 0.65vh; font-weight: 600; letter-spacing: 0.1vh; text-transform: uppercase; color: var(--muted); }
    .of__value {
        margin-top: 0.19vh; font-size: 1.05vh; font-weight: 600; color: #F2F0EB;
        display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
    }
    .of__money {
        flex-shrink: 0; display: flex; align-items: baseline; gap: 0.31vh;
        font-size: 2.08vh; font-weight: 600; color: var(--gold); letter-spacing: -0.03vh;
    }
    .of__money span { font-size: 1.05vh; }

    .of__acts { display: flex; gap: 0.74vh; margin-top: 0.99vh; }
    .of__btn {
        flex: 1; height: 3.47vh; border-radius: 0.87vh;
        display: flex; align-items: center; justify-content: center; gap: 0.62vh;
        background: #26262A; color: #F2F0EB;
        font-size: 1.28vh; font-weight: 500;
    }
    .of__btn b {
        display: flex; align-items: center; justify-content: center;
        width: 1.74vh; height: 1.74vh; border-radius: 0.5vh;
        background: rgba(255, 255, 255, .1); font-size: 0.81vh; font-weight: 600;
    }
    .of__btn--yes { background: var(--gold); color: #221903; font-weight: 600; }
    .of__btn--yes b { background: rgba(34, 25, 3, .18); color: #221903; }

    .of__bar {
        position: absolute; left: 0; right: 0; bottom: 0; height: 0.31vh;
        background: rgba(255, 255, 255, .06);
    }
    .of__bar i {
        display: block; height: 100%; background: var(--gold);
        transition: width .1s linear;
    }
</style>
